import { Language } from '../../lang/Language'
import { BoardState, Deal, Flop, PreDeal, River, Showdown, Turn } from './BoardState.types'

export class BoardStates {
  public static PreDeal: PreDeal = <PreDeal>{
    tag: 'predeal',
    description: Language.strings.states.board.predeal
  }

  public static Deal: Deal = <Deal>{
    tag: 'deal',
    description: Language.strings.states.board.deal
  }

  public static Flop: Flop = <Flop>{
    tag: 'flop',
    description: Language.strings.states.board.flop
  }

  public static Turn: Turn = <Turn>{
    tag: 'turn',
    description: Language.strings.states.board.turn
  }

  public static River: River = <River>{
    tag: 'river',
    description: Language.strings.states.board.river
  }

  public static Showdown: Showdown = <Showdown>{
    tag: 'showdown',
    description: Language.strings.states.board.showdown
  }

  static isPreDeal(s: BoardState): s is PreDeal {
    return s.tag === 'predeal'
  }

  static isDeal(s: BoardState): s is Deal {
    return s.tag === 'deal'
  }

  static isFlop(s: BoardState): s is Flop {
    return s.tag === 'flop'
  }

  static isTurn(s: BoardState): s is Turn {
    return s.tag === 'turn'
  }

  static isRiver(s: BoardState): s is River {
    return s.tag === 'river'
  }

  static isShowdown(s: BoardState): s is Showdown {
    return s.tag === 'showdown'
  }
}
